import { render, staticRenderFns } from "./SipDispositionDialog.vue?vue&type=template&id=23f309d0&scoped=true"
import script from "./SipDispositionDialog.vue?vue&type=script&lang=js"
export * from "./SipDispositionDialog.vue?vue&type=script&lang=js"
import style0 from "./SipDispositionDialog.vue?vue&type=style&index=0&id=23f309d0&prod&scoped=true&lang=css"
import style1 from "./SipDispositionDialog.vue?vue&type=style&index=1&id=23f309d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f309d0",
  null
  
)

export default component.exports